import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import type { Corral } from '../../stores/corrales/corral';
import type { ActualizarCorral, RegistrarCorral } from '../../stores/corrales/corrales.store';
import { useUIStore } from '../../stores/ui/ui.store';
import type { CommonEntityFormProps } from '../../utils/common-entity-form-props';
import { getLengthOrErrorText } from '../../utils/get-length-or-error-text';
import AppTextField from '../ui/AppTextField';
import EditForm from '../ui/EditForm';

const validationSchema = yup.object({
  id: yup.number(),
  nombre: yup.string().required('El nombre es requerido')
});

type CorralFormProps = {
  corral?: Corral;
  onSave:
    | ((values: ActualizarCorral) => Promise<void>)
    | ((values: RegistrarCorral) => Promise<number | null>);
  onClose?: () => void;
} & CommonEntityFormProps;

const CorralForm = ({
  corral,
  esAgregar,
  onSave,
  onDelete,
  onActivate,
  onClose
}: CorralFormProps) => {
  const esEditar = !esAgregar;
  const activo = esAgregar || corral?.activo === true;
  const inactivo = !activo;
  const status = activo ? 'ACTIVO' : 'INACTIVO';
  const { loading } = useUIStore();
  const initialValues = {
    id: corral?.id ?? '',
    nombre: corral?.nombre ?? ''
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const newId = await onSave(values);
      if (newId) {
        formik.resetForm();
      }
    },
    enableReinitialize: true
  });

  const reset = () => formik.resetForm({ values: initialValues });
  let props = {
    module: 'corrales',
    title: 'Corrales',
    readonly: !activo,
    loading: loading,
    showActivate: false,
    showDelete: esEditar,
    onSave: formik.handleSubmit,
    onClear: reset,
    onDelete: onDelete,
    onActivate: onActivate
  };

  return (
    <EditForm
      // title="Corrales"
      // readonly={!activo}
      // loading={loading}
      // showActivate={esEditar}
      // showDelete={esEditar}
      // onSave={formik.handleSubmit}
      // onClear={reset}
      // onDelete={onDelete}
      // onActivate={onActivate}
      {...(onClose ? { ...props, onClose } : { ...props, returnLink: '/corrales' })}
    >
      <Grid>
        <Grid container spacing={2}>
          <Grid>
            <AppTextField
              name="id"
              label="Código"
              placeholder="Código"
              value={formik.values.id}
              readOnly={true}
            />
          </Grid>
          <Grid size="grow">
            <AppTextField
              name="nombre"
              label="Nombre"
              placeholder="Nombre"
              maxLength={40}
              disabled={loading || inactivo}
              value={formik.values.nombre}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.nombre && Boolean(formik.errors.nombre)}
              helperText={getLengthOrErrorText(
                formik.touched.nombre ? formik.errors.nombre : '',
                formik.values.nombre.length,
                40
              )}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid size={{ xs: 2 }}>
        <AppTextField label="Status" value={status} disabled={true} />
      </Grid>
    </EditForm>
  );
};

export default CorralForm;
